import FormElement from './form-element.js';

class OptionSelects extends FormElement {
	#container;
	#elements = {};

	constructor(container) {
		super();

		if (container instanceof jQuery) {
			container = container[0];
		}

		this.#container = container;

		this.#init();
	}

	#init() {
		const selects = Array.from(this.#container.querySelectorAll('.option-select'));

		for (const el of selects) {
			const select = el.querySelector('select');
			const name = select.name;
			const value = select.value;

			this.#elements[ name ] = el;
			super.store(name, value);

			select.addEventListener('input', e => {
				this.set(name, select.value);
				select.blur();
			});

			this.update(name, select.value);

			const mutationObserver = new window.MutationObserver(() => this.update(name, select.value));

			mutationObserver.observe(select, {
				childList: true,
				subtree: true,
				characterData: true,
			});
		}
	}

	set(name, value, ... args) {
		return this.#handleUpdate(name, value, true, ... args);
	}

	update(name, value) {
		return this.#handleUpdate(name, value, false);
	}

	reset(name = null) {
		if (!name) {
			for (const key of Object.keys(this.#elements)) {
				this.reset(key);
			}
			return;
		}

		const select = this.#elements[ name ];

		return this.update(name, '');
	}

	#handleUpdate(name, value = null, callback = true, ... args) {
		const el = this.#elements[ name ];
		const select = el.querySelector('select');
		const title = el.querySelector('.btn-select');

		const changed = value.toString() !== select.value;

		select.value = value;

		super.store(name, value);

		title.textContent = select.selectedOptions.length ?
			select.selectedOptions[0].textContent :
			select.options[0].textContent;

		super.runCallback(name, 'update', ... args);

		if (callback) {
			super.runCallback(name, 'set', ... args);
		}

		return changed;
	}
}

function init(container) {
	return new OptionSelects(container);
}

export default { init }
